import React from 'react';
import { Col } from 'react-bootstrap';
import DateControl from '../../../components/Fields/DateControl';
import DateField from '../../../components/Fields/DateField';
import Field from '../../../components/Fields/Field';
import SelectListField from '../../../components/Fields/SelectListField';
import TextboxField from '../../../components/Fields/TextboxField';
import { ControlProps, FieldProps, LabelProps } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import WorkflowModel from '../../../models/WorkflowModel';
import WorkflowTaskAddPriceModel from '../../../models/WorkflowTaskAddPriceModel';

interface IProps {
    formData: WorkflowTaskAddPriceModel
    getLabelProps: (fieldName: string) => LabelProps
    getControlProps: (fieldName: string) => ControlProps
    getFieldProps: (fieldName: string) => FieldProps
    workflow: WorkflowModel
}

const TaskAddPriceView: React.FC<IProps> = ({ formData, getLabelProps, getControlProps, getFieldProps, workflow }) => {
    const priceTypes = useSelectListOptions('api/v1/selectlist/PriceTypes', '-- Select price type');
    const priceTrancheTypes = useSelectListOptions('api/v1/selectlist/PriceTrancheTypes', '-- No volume based pricing');
    const priceTranches = useSelectListOptions('api/v1/selectlist/PriceTranches?priceTrancheTypeId=' + formData.price.priceTrancheTypeId, '-- No volume based pricing');
    const businessPartners = useSelectListOptions('api/v1/selectlist/BusinessPartnersForItem?itemId=' + workflow.itemRevision.itemId, '-- Select business-partner');
    const currencies = useSelectListOptions('api/v1/selectlist/Currencies', '-- Select currency');
    const incoTerms = useSelectListOptions('api/v1/selectlist/IncoTerms', '-- Select incoterms');

    return (
        <>
            <SelectListField {...getFieldProps('workflowTaskAddPriceModel.price.priceTypeId')} options={priceTypes} />
            {businessPartners && businessPartners.length > 0 && (< SelectListField {...getFieldProps('workflowTaskAddPriceModel.price.businessPartnerId')} options={businessPartners} />)}
            <SelectListField {...getFieldProps('workflowTaskAddPriceModel.price.priceTrancheTypeId')} options={priceTrancheTypes} />
            <SelectListField {...getFieldProps('workflowTaskAddPriceModel.price.priceTrancheId')} options={priceTranches} />
            <SelectListField {...getFieldProps('workflowTaskAddPriceModel.price.currencyId')} options={currencies} />
            <TextboxField {...getFieldProps('workflowTaskAddPriceModel.price.amount')} />
            <SelectListField {...getFieldProps('workflowTaskAddPriceModel.price.incoTermId')} options={incoTerms} />
            <Field {...getLabelProps('workflowTaskAddPriceModel.price.beginDate')}>
                <Col md='4' style={{ padding: 0 }}>
                    <DateControl {...getControlProps('workflowTaskAddPriceModel.price.beginDate')} />
                </Col>
                <Col md='8'>
                    <DateField {...getFieldProps('workflowTaskAddPriceModel.price.endDate')} />
                </Col>
            </Field>
            <TextboxField {...getFieldProps('workflowTaskAddPriceModel.price.remarks')} />
        </>
    )

}
export default TaskAddPriceView;